export class LocationResponse {
	id: number;
	company: number;
	address: string;
	name: string;
}